import urlJoin from 'url-join'

export function buildUrls(data: { serverBase: string, accountUrl: string }) {
    return {
        accountUrl: data.accountUrl,
        checkMFAStatus: urlJoin(data.serverBase, '/public/mfa/ck'),
        // 后续可以添加更多API端点
    }
}

export interface IUrls {
    accountUrl: string
    checkMFAStatus: string
} 